export default __webpack_public_path__ + "static/media/Wednesday_03.6b1898fc.png";